//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/Section.js";
import "../no/ugmath.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"KeepOriginal",1,0],[0,"RenameComponent",1,0],[1,"SelectComponent",0,"Assemblies.SelectComponentList",0],[1,"SplittingCurves",0,"Section",0],[0,"SplittingDirection",1,0],[0,"WizardType",1,0]],[[["componentTag"],"SaveAndGetComponentParent",{R_:{parentTag:"NXObject"}},1,0],[["componentTag"],"GetComponentFullName",{R_:{fullPartName:''}},1,0],[["componentTag"],"GetComponentOrigin",{R_:{origin:''}},1,0],[["componentTag"],"GetComponentTransform",{R_:{componentTransform:''}},1,0],[[],"PrepairToSplitInsert",{},0,0],[["featureType","featureNameSubString"],"FindLinkedBodyFeatureAndSource",{},2,0],[[],"FindLinkedBodyFeatureAndSourceForAll",{},0,0],[["sourceObjects"],"ReverseTrimAndRelinkSourceAndCreateUDOForAll",{},1,0],[["numSourceObjectsOld","sourceObjectsOld"],"SetLinkFeatureAndSourceObject",{},0,0]],[]];
SPLM.Tooling.SplitInsertBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.SplitInsertBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;